import LinksListContainer from './list/LinksList';

export default [
  {
    path: '/links',
    exact: true,
    component: LinksListContainer
  }
];
